export default __webpack_public_path__ + "static/media/quiz-q1.61eb091a.png";